import { Slot } from '@radix-ui/react-slot'
import React, { forwardRef } from 'react'

import { mergeRefs } from 'utils/ref_utils'

import { useHeadlessListboxContext, useHeadlessListboxState } from './context'

interface HeadlessListboxControlProps extends React.HTMLAttributes<HTMLElement> {
  asChild?: boolean;
}

export const HeadlessListboxControl = forwardRef<
  HTMLElement,
  HeadlessListboxControlProps
>(({ asChild, ...props }, forwardedRef) => {
  const { controlRef } = useHeadlessListboxContext()
  const selectedOption = useHeadlessListboxState(({ selectedOption }) => selectedOption)

  const Component = asChild ? Slot : 'div'

  function renderChildren () {
    return (
      <Component
        {...props}
        aria-activedescendant={selectedOption || undefined}
        ref={mergeRefs(controlRef, forwardedRef)}
      />
    )
  }

  return <>{renderChildren()}</>
})

HeadlessListboxControl.displayName = 'HeadlessListbox.Control'
